import type { FunctionComponent } from "react";
import { ManageFiltersAdminPartial } from "../../../../partials/admin/menus/proposals/manage-filters-slider.admin.partial";

export const ManageFiltersAdminScreen: FunctionComponent = () => {
  return <ManageFiltersAdminPartial />;
};
